import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { useContext } from "react";
import { PriceWithCurrency } from "../../../../../../base/text/price-with-currency/index.js";
import contextBabylon from "../../../../../../../context/index.js";
import { normalizePrice } from "../../../utils/index.js";
import * as S from "./styled.js";
const Prices = (props)=>{
    const { isDeal , isBlackfriday =false , literals  } = props;
    const price = normalizePrice(props.price);
    const { Currency , Language  } = useContext(contextBabylon);
    const priceProps = {
        price: price.value,
        currency: Currency,
        locale: Language
    };
    if (!price?.value) return /*#__PURE__*/ _jsx(S.OnlyIcon, {
        className: "nico-magnifier"
    });
    return /*#__PURE__*/ _jsxs(S.PricesWrapperMobile, {
        "data-testid": "Prices",
        itemProp: "offers",
        itemScope: false,
        itemType: "https://schema.org/AggregateOffer",
        children: [
            /*#__PURE__*/ _jsx("meta", {
                itemProp: "lowPrice",
                content: price.value.toString()
            }),
            /*#__PURE__*/ _jsx("meta", {
                itemProp: "priceCurrency",
                content: Currency
            }),
            isDeal ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(S.PriceTopDealMobile, {
                        children: [
                            price.discount && /*#__PURE__*/ _jsx("span", {
                                className: "discount",
                                children: price.discount
                            }),
                            price.market_value && /*#__PURE__*/ _jsx("span", {
                                className: "old-price",
                                children: /*#__PURE__*/ _jsx(PriceWithCurrency, {
                                    props: {
                                        ...priceProps,
                                        price: price.market_value
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(S.PriceCurrentDealMobile, {
                        "data-testid": "PriceCurrentDeal",
                        className: classNames({
                            'is-blackfriday': isBlackfriday
                        }),
                        children: /*#__PURE__*/ _jsx(PriceWithCurrency, {
                            props: priceProps
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(S.PriceTopMobile, {
                        children: [
                            price.from && /*#__PURE__*/ _jsx("span", {
                                className: "from",
                                children: literals?.fromCaption
                            }),
                            price.market_value && /*#__PURE__*/ _jsx("span", {
                                className: "old-price",
                                children: /*#__PURE__*/ _jsx(PriceWithCurrency, {
                                    props: {
                                        ...priceProps,
                                        price: price.market_value
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(S.PriceCurrentMobile, {
                        children: /*#__PURE__*/ _jsx(PriceWithCurrency, {
                            props: priceProps
                        })
                    }),
                    price.paxValue && /*#__PURE__*/ _jsxs(S.PricePaxValueMobile, {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "per-person",
                                children: literals?.perPerson
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "pax-value",
                                children: /*#__PURE__*/ _jsx(PriceWithCurrency, {
                                    props: {
                                        ...priceProps,
                                        price: price.paxValue
                                    }
                                })
                            })
                        ]
                    }),
                    price.caption && /*#__PURE__*/ _jsx(S.PriceCaptionMobile, {
                        children: literals?.priceCaption
                    })
                ]
            })
        ]
    });
};
export default Prices;

//# sourceMappingURL=index.js.map